import React, {} from 'react'
import './index.less'

interface SectionTitleProps{
	title:string;
}

export const AppSectionTitle = (props: SectionTitleProps) =>{
	return (
		<div className='app-section-title-title'>
			<div className="app-section-title-icon"></div>
			<div className="app-section-title-text">{props.title}</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/qcc/AppForm/AppSectionTitle.tsx